import Crop169Icon from "@mui/icons-material/Crop169";
import Crop32Icon from "@mui/icons-material/Crop32";
import Crop75Icon from "@mui/icons-material/Crop75";
import CropDinIcon from "@mui/icons-material/CropDin";
import HdrAutoIcon from "@mui/icons-material/HdrAuto";
import { SvgIconProps } from "@mui/material/SvgIcon";
import React from "react";

// アスペクト比からアイコンを取得するマッピング関数
export const getIconForRatio = (ratio: string): React.ComponentType<SvgIconProps> => {
  switch (ratio) {
    case "21:9":
    case "9:21":
      return Crop169Icon;
    case "16:9":
    case "9:16":
      return Crop32Icon;
    case "4:3":
    case "3:4":
      return Crop75Icon;
    case "3:2":
    case "2:3":
      return Crop32Icon;
    case "5:4":
    case "4:5":
      return Crop75Icon;
    case "1:1":
      return CropDinIcon;
    case "AUTO":
      return HdrAutoIcon;
    default:
      return Crop32Icon;
  }
};

// 回転角度を取得する関数
export const getRotationForRatio = (ratio: string): string => {
  switch (ratio) {
    case "9:21":
    case "9:16":
    case "3:4":
    case "2:3":
    case "4:5":
      return "90deg";
    default:
      return "0deg";
  }
};

// アスペクト比を論理的な順序でソートする関数
export const sortAspectRatios = (ratios: string[]): string[] => {
  // AUTO → 横長（21:9 → 16:9 → 4:3 → 3:2 → 5:4） → 正方形（1:1） → 縦長（2:3 → 3:4 → 4:5 → 9:16 → 9:21）
  const order = ["AUTO", "21:9", "16:9", "4:3", "3:2", "5:4", "1:1", "2:3", "3:4", "4:5", "9:16", "9:21"];

  return ratios.sort((a, b) => {
    const indexA = order.indexOf(a);
    const indexB = order.indexOf(b);

    // orderにない比率は最後に配置
    if (indexA === -1 && indexB === -1) return 0;
    if (indexA === -1) return 1;
    if (indexB === -1) return -1;

    return indexA - indexB;
  });
};
